<template>
    <div class="Write">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>글쓰기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_close.png" width="50" alt="이전" />
                </a>
            </div>
            <button class="btn-write"
                    @click="formSend"
            >   {{ (pBoardNum) ? '수정' : '등록'}}
            </button>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <div class="flex justify-between mrg-top-15">
                <select class="width-100"
                        v-model="nMenuNum"
                        @change="getCategoryList">
                    <option v-for="item in boardMenu"
                            :key="item.nMenuNum"
                            :value="item.nMenuNum">
                        {{item.strMenuName}}
                    </option>
                </select>
            </div>
            <div class="mrg-top-15"
                 v-if="boardCategory.length>0">
                <select class="width-100"
                        v-model="nCategoryNum">
                    <option value="">분류선택</option>
                    <option v-for="item in boardCategory"
                            :key="item.nCategoryNum"
                            :value="item.nCategoryNum">
                        {{item.strCategoryName}}
                    </option>
                </select>
            </div>
            <div class="mrg-top-15"
                 v-if="boardRegion.length>0">
                <select class="width-100"
                        v-model="nRegionNum">
                    <option value="">지역선택</option>
                    <option v-for="item in boardRegion"
                            :key="item.nRegionNum"
                            :value="item.nRegionNum">
                        {{item.strRegionName}}
                    </option>
                </select>
            </div>
            <div class="write-area">
                <input type="text"
                       placeholder="제목을 입력하세요."
                       ref="strTitle"
                       v-model="strTitle"
                       style="ime-mode:active;"
                />
            </div>
            <!--
                종사자이야기 게시판에서만 일반글 / 질문글 옵션이 보이고
                그외 게시판에서는 모두 일반글로만 게시글이 등록되어야 함
            -->
            <div class="flex justify-between mrg-top-15 mrg-btm-15" v-if="nMenuNum==1">
                <button class="width-100 btn-board mrg-right-10"
                        @click="bIsknowledgeFlag='N'"
                        :class="bIsknowledgeFlag == 'N' ? 'active' : '' ">
                    일반글
                </button>
                <button class="width-100 btn-board"
                        @click="bIsknowledgeFlag='Y'"
                        :class="bIsknowledgeFlag == 'Y' ? 'active' : '' ">
                    질문글
                </button>
            </div>
            <div class="flex justify-between mrg-top-15 mrg-btm-15">
                <input type="file"
                       id="fileUpload"
                       ref="fileUpload"
                       style="display: none"
                       multiple
                       @change="fileUpload($event)" />
                <button class="width-100 btn-board mrg-right-10"
                        @click="$refs.fileUpload.click()">
                    파일
                </button>
                <input type="file"
                       id="imgUpload"
                       ref="imgUpload"
                       style="display: none"
                       multiple
                       accept=".png, .jpg, .jpeg, .gif"
                       @change="imgUpload($event)" />
                <button class="width-100 btn-board mrg-right-10"
                        @click="$refs.imgUpload.click()">
                    사진
                </button>
                <button class="width-100 btn-board"
                        @click="boardSurveySlideView">
                    설문
                </button>
            </div>
            <div class="previewArea">
                <div class="previewSurvey"
                     v-if="boardDetail.oPoll.nPollCnt > 0">
                    <ul>
                        <li>
                            <span class="FileName">설문</span>|
                            <span class="FileSize">{{boardDetail.oPoll.nPollCnt}}개 항목</span>
                            <a class="att-close" @click="surveyDelete()"></a>
                        </li>
                    </ul>
                </div>
                <div class="previewFile"
                     v-if="boardDetail.oFile && boardDetail.oFile.length>0">
                    <ul>
                        <li v-for="(data, index) in boardDetail.oFile"
                            :key="index">
                            <span class="FileName">{{data.strFileName}}</span>|
                            <span class="FileSize">{{data.nFileSizeK | getfileSize}}</span>
                            <a class="att-close" @click="fileUploadDelete(index, data.nFileNum)"></a>
                        </li>
                    </ul>
                </div>
                <div class="previewImg"
                     v-if="boardDetail.oImage && boardDetail.oImage.length>0">
                    <ul>
                        <li v-for="(data, index) in boardDetail.oImage"
                            :key="index"
                            :class="(data.bRepresentation == 'Y') ? 'sel' : '' ">
                            <a @click="imgUploadRepresentation(index)">
                                <span v-if="data.bRepresentation == 'Y'">대표</span>
                                <img :src="data.strImageLink" width="92" height="100" alt="" />
                                <button class="img-close" @click.stop="imgUploadDelete(index, data.nImageNum)">삭제</button>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="mrg-btm-20">
                <summernoteLite :config="config" @ready="readyState" v-model="strContent" style="ime-mode:active;"></summernoteLite>
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
    import summernoteLite from "vue-summernote-lite";

    export default {
        name: 'Write',
        components: { summernoteLite },
        data() {
            return {
                isSending:false,            // 전송체크
                boardMenu:{},               // 게시판 Combo
                boardCategory:{},           // 카테고리 Combo
                boardRegion:{},             // 지역 Combo
                nFIieNum:1,                 // File Upload 수
                nImgFIieNum:1,              // Img Upload 수
                editorId:'',
                config: {
                    placeholder: "",
                    // fontSizes: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '32', '36', '48'],
                    width: '100%',
                    lang: "ko-KR",
                    toolbar: [
                        // ['fontname', ['fontsize']],
                        // ['color', ['color']],
                        // ['para', ['ul', 'ol','paragraph']],
                        // ['insert', ['link']],
                        // ['style', ['style','bold', 'italic', 'underline', 'clear' ]],
                       // ['view', ['codeview']]
                    ],
                    height: 200,
                },
                nMenuNum:1,                    // 게시판 메뉴
                nBoardNum:'',                   // 게시글 번호
                nCategoryNum:'',                // 카테고리 정보
                nRegionNum:'',                  // 지역정보
                bIsknowledgeFlag:'N',           // 질문글(지식인글) : Y 질문글, N : 일반글
                boardDetail:{
                    oPoll: {
                        nPollCnt:0
                    },
                    oFile:[],
                    oImage:[],
                    detail:{}
                },
                strDeleteImageNum:[],           // 삭제한 이미지 고유값을 콤마를 구분하여 문자열로 전달 (필요에 따라 값을 넣어주시면 됩니다. ) ex) 1,2,3,4,5
                strResourceNum:[],              // 업로드되는 이미지/파일의 고유값을 콤마를 구분하여 문자열로 전달  ex) 1,2,3,4,5
                strTitle : '',                  // 제목
                strContent: '',  // 내용
            }
        },
        props: ['pBoardNum'],
        // 계산된 속성
        computed: {
        },
        // 감시자
        watch: {
            bIsknowledgeFlag(_new){
                if (_new == 'Y'){
                    this.toastMsg('질문글로 작성시 답변자에게 그레를 선물할 수 있습니다.\n' +
                        '단,  답변 채택 후에는 글 삭제를 할 수 없습니다.\n',2000);
                }
            }
        },
        // $el 생성전
        created() {
            this.nMenuNum = this.storageGet('vuex','boardActiveCode');
            this.nBoardNum = this.pBoardNum;
        },
        // $el 생성후
        mounted() {
            window.callbackBackKey = this.callbackBackKey;

            // 카테고리 호출
            this.getCategoryList();

            // 수정시 게시글 상세 불러오기
            if (this.pBoardNum){
                this.getBoardDtail();
            }
        },
        methods: {
            // APP 뒤로가기
            callbackBackKey(){
                this.slidePanelClose();
            },
            // rest api 호출 후 에러시 처리
            errorAxios(){
                this.isSending = false;
            },
            // 에디터 초기 셋팅
            readyState(editor) {
                this.editorId = editor.$el.id;
                editor.summernote('code', this.strContent);
                editor.$on("change", contents => {
                    this.strContent = contents;
                });
                editor.$on("focus", function() {
                    // console.log("onFocus");
                });
                editor.$on("blur", function() {
                    // console.log("onBlur");
                });
                editor.$on("paste", function() {
                    // console.log("onPast");
                });
            },
            // 카테고리 검색
            getCategoryList(){
                let param = {};
                let menuLink = (this.nMenuNum) ? 'list/'+this.nMenuNum : 'list';
                this.ajaxGetAuth('/api/v1/category/'+menuLink, param, this.getCategoryListResult);
            },
            // 카테고리 검색 결과
            getCategoryListResult(response) {
                this.nCategoryNum= '';
                this.nRegionNum= '';
                if (response.result.code == 0){
                    this.boardMenu = response.oMenuInfo.list;
                    this.boardCategory = response.oCategoryInfo.list;
                    this.boardRegion = response.oRegionInfo.list;
                    this.nMenuNum = response.oMenuInfo.setting.nMenuSelected;
                }else{
                    this.boardCategory = {};
                    this.boardRegion = {};
                    this.toastMsg(response.result.resultNoti.message,1500);
                }
                this.$refs.strTitle.focus();
            },
            // 게시글 검색
            getBoardDtail(){
                let param = {};
                let boardActiveCode = this.nMenuNum;
                let boardSeq = this.nBoardNum;
                this.ajaxGetAuth('/api/v1/board/modify/'+boardActiveCode+'/'+boardSeq, param, this.getBoardDtailResult);
            },
            // 게시글 검색 결과
            getBoardDtailResult(response) {
                if (response.result.code == 0){
                    if (this.pBoardNum){
                        this.strTitle = response.oBoardInfo.detail.oBoard.strBoardTitle;
                        this.bIsknowledgeFlag = (response.oBoardInfo.detail.oBoard.oKnowledgeIn.bKnowledgeIn) ? 'Y' : 'N';

                        // eslint-disable-next-line no-undef
                        $('#'+this.editorId).summernote('code' , response.oBoardInfo.detail.oBoard.strContent)

                        if (response.oBoardInfo.oFile && response.oBoardInfo.oFile.list && response.oBoardInfo.oFile.list.length>0){
                            this.boardDetail.oFile = response.oBoardInfo.oFile.list;
                        }

                        if (response.oBoardInfo.oImage && response.oBoardInfo.oImage.list && response.oBoardInfo.oImage.list.length>0){
                            this.boardDetail.oImage = response.oBoardInfo.oImage.list;
                        }

                        if (response.oBoardInfo.oPoll){
                            this.boardDetail.oPoll = response.oBoardInfo.oPoll;
                        }else{
                            this.boardDetail.oPoll = {
                                nPollCnt:0
                            }
                        }

                        this.boardDetail.detail = response.oBoardInfo.detail;
                    }else{
                        this.boardDetail.oPoll = {
                            nPollCnt:0
                        }
                    }

                }else{
                    this.toastMsg(response.result.resultNoti.message,1500);
                }
            },
            // 파일 업로드
            fileUpload(e){
                if(e.target.value.length > 0){
                    for (let i = 0; i < e.target.files.length; i++) {
                        // 100MB (104857600)
                        // 30MB   (31457280)
                        if (e.target.files[i].size > 31457280){
                            this.$refs.fileUpload.value = '';
                            this.mintAlert('30MB 용량 이하로만 첨부가 가능합니다.')
                            return false
                        }
                    }

                    // 더블클릭 방지 체크
                    if (this.isSending){
                        return false;
                    }

                    this.isSending = true;

                    for (let i = 0; i < e.target.files.length; i++) {
                        let formData = new FormData();
                        formData.append('nBoardNum', (this.nBoardNum) ? this.nBoardNum : 0 );
                        formData.append('nFIieNum', this.nFIieNum);
                        formData.append('oFile', e.target.files[i]);
                        this.ajaxUpload('/api/v1/board/write/upload/file', formData,this.fileUploadResult);
                        this.nFIieNum++;
                    }
                }else{
                    this.isSending = false;
                }

            },
            // 파일 업로드 결과
            fileUploadResult(response, varParam) {
                console.log(varParam.get('oFile'))
                this.isSending = false;

                if (response.result.code == 0){
                    this.boardDetail.oFile.push({"strFileName" : varParam.get('oFile').name,"nFileSizeK" : (parseInt(varParam.get('oFile').size)/1024),"nFileNum" : response.fileInfo.nFileNum})
                }else{
                    this.$refs.fileUpload.value = '';
                    this.toastMsg(response.result.resultNoti.message,1500);
                }
            },
            // 파일 삭제
            fileUploadDelete(index, nFileNum){
                // 더블클릭 방지 체크
                if (this.isSending){
                    return false;
                }
                this.isSending = true;
                this.boardDetail.oFile.splice(index, 1);
                let nBoardNum = (this.nBoardNum) ? this.nBoardNum : 0;
                let formData = new FormData();
                this.ajaxUpload('/api/v1/board/delete/file/'+this.nMenuNum+'/'+nBoardNum+'/'+nFileNum, formData,this.fileUploadDeleteResult);
            },
            // 파일 삭제 결과
            fileUploadDeleteResult() {
                this.isSending = false;
            },
            // 이미지 업로드
            imgUpload(e){
                if(e.target.value.length > 0){
                    // 더블클릭 방지 체크
                    if (this.isSending){
                        return false;
                    }

                    this.isSending = true;

                    for (let i = 0; i < e.target.files.length; i++) {
                        let formData = new FormData();
                        formData.append('nBoardNum', (this.nBoardNum) ? this.nBoardNum : 0 );
                        formData.append('nFIieNum', this.nImgFIieNum);
                        formData.append('oFile', e.target.files[i]);
                        this.ajaxUpload('/api/v1/board/write/upload/image', formData,this.imgUploadResult);
                        this.nImgFIieNum++;
                        // this.uploadImgData.push(e.target.files[i]);
                    }
                }else{
                    this.isSending = false;
                }

            },
            // 이미지 업로드 결과
            imgUploadResult(response) {
                this.isSending = false;

                if (response.result.code == 0){
                    let image = "<img src='"+response.fileInfo.srtImageUrl+"' />";
                    // eslint-disable-next-line no-undef
                    $('#'+this.editorId).summernote('code' , $('#'+this.editorId).summernote('code') + "<br>"+image);

                    let bRepresentation = (this.boardDetail.oImage.length == 0) ? 'Y' : 'N';
                    this.boardDetail.oImage.push({"strImageLink" : response.fileInfo.srtImageUrl,"nImageNum" : response.fileInfo.nFileNum,"bRepresentation" : bRepresentation})
                }else{
                    this.$refs.imgUpload.value = '';
                    this.toastMsg(response.result.resultNoti.message,1500);
                }
            },
            // 이미지 삭제
            imgUploadDelete(index, nFileNum){
                this.strDeleteImageNum.push(nFileNum);
                this.boardDetail.oImage.splice(index, 1);
            },
            // 설문지 슬라이드
            boardSurveySlideView(){
                let props = {
                    nBoardNum : (this.nBoardNum) ? this.nBoardNum : 0,
                    oPoll : (this.boardDetail.oPoll) ? this.boardDetail.oPoll.list : ''
                };
                const panel =this.$showPanel({
                    component: () => import('@/views/board/Survey'),
                    props: props,
                    openOn: 'right',
                    width:screen.width,
                });
                panel.promise.then(result => {
                    window.callbackBackKey = this.callbackBackKey;
                    console.log(result)
                    if (result.result === "close"){
                        this.nBoardNum = result.nBoardNum;
                        this.boardDetail.oPoll.nPollCnt = result.nPollCnt;
                    }
                });
            },
            // 설문지 삭제
            surveyDelete(){
                // 더블클릭 방지 체크
                if (this.isSending){
                    return false;
                }

                this.isSending = true;
                let formData = new FormData();
                this.ajaxPostAuth('/api/v1/board/delete/poll/'+this.nMenuNum+'/'+this.nBoardNum, formData,this.surveyDeleteResult);
            },
            // 설문지 삭제 결과
            surveyDeleteResult(response) {

                this.toastMsg(response.result.resultNoti.message,1500);
                if (response.result.code == 0){
                    if (this.pBoardNum){
                        this.getBoardDtail();
                    }else{
                        this.nBoardNum = '';
                        this.boardDetail.oPoll = {
                            nPollCnt:0
                        }
                    }

                }
                this.boardDetail.oPoll.nPollCnt=0;
                this.isSending = false;
            },
            // 대표 이미지 설정
            imgUploadRepresentation(index){
                this.boardDetail.oImage.forEach(function (key) {
                    key.bRepresentation = 'N';
                })

                this.boardDetail.oImage[index].bRepresentation = 'Y';
            },
            // 저장
            formSend(){
                // 더블클릭 방지 체크
                if (this.isSending){
                    return false;
                }

                let vm = this;
                this.boardDetail.oFile.forEach(function (key) {
                    vm.strResourceNum.push(key.nFileNum);
                })

                this.boardDetail.oImage.forEach(function (key) {
                    vm.strResourceNum.push(key.nImageNum);
                })

                // 종사자이야기 게시판에서만 일반글 / 질문글 옵션이 보이고
                // 그외 게시판에서는 모두 일반글로만 게시글이 등록되어야 함
               if (this.nMenuNum != '1'){
                    this.bIsknowledgeFlag = 'N';
                }

                let formData = new FormData();
                formData.append('strTitle', this.strTitle);
                formData.append('strContent', this.strContent);
                formData.append('nBoardNum', this.nBoardNum);
                formData.append('nMenuNum', this.nMenuNum);
                formData.append('nCategoryNum', this.nCategoryNum);
                formData.append('nRegionNum', this.nRegionNum);
                formData.append('strUsingTime', '');
                formData.append('strReadModel', '');
                formData.append('strWriteModel', '');
                formData.append('bIsNotice', 'N');
                formData.append('bEventIsApply', '');
                formData.append('strEventStartDate', '');
                formData.append('strEventEndDate', '');
                formData.append('strEventDeclareDate', '');
                formData.append('strEventBannerImg', '');
                formData.append('strEventLinkUrl', '');
                formData.append('bIsReserved', '');
                formData.append('strReservedDate', '');
                formData.append('bIsTopFix', '');
                formData.append('strTopFixBrd', '');
                formData.append('bSecret', '');
                formData.append('bIsknowledgeFlag', this.bIsknowledgeFlag);
                formData.append('strDeleteImageNum', this.strDeleteImageNum);
                formData.append('strResourceNum', this.strResourceNum);

                this.isSending = true;

                this.ajaxPostAuth('/api/v1/board/write/register', formData, this.formSendResult);
            },
            // 저장 결과
            formSendResult(response) {
                this.isSending = false;

                this.toastMsg(response.result.resultNoti.message,1500);
                if (response.result.code == 0){
                    this.gotoHistoryUrl(this.nMenuNum);

                    if (this.pBoardNum){
                        this.slidePanelClose('detail_reload');
                    }else{
                        this.slidePanelClose('write_reload');
                        this.gotoBoard(this.nMenuNum)
                    }
                }
            },
        },
        // $el 해체
        destroyed(){

        }
    }
</script>

<style scoped>

    .btn-write { position: absolute;top: 8px; right: 15px;background: #2e9cff; color: #fff;border: 0;padding: 5px 10px;font-size: 16px;border-radius: 5px;}

    .write-area {padding: 15px 20px 15px 20px;border-bottom: 2px solid #2e9cff;margin: 0 -20px;height: 30px;position: relative;}
    .write-area input{height: 30px;line-height: 30px;font-size: 17px; width: 100%;}

    .btn-board {color: #969696 ; background: #e0e0e0; border: 2px solid #e0e0e0; height: 45px; line-height: 45px; text-align: center; font-size: 15px; border-radius: 10px;}
    .btn-board.active {color:#017ff0; background: #fff; border: 2px solid #017ff0}

    .previewArea div:last-child{ border-top: 1px dotted #dcdcdc; padding-top: 15px; }

    .previewSurvey {margin: 10px 0;width: 100%;}
    .previewSurvey ul li{color: #696969;font-size: 12px;height: 24px;}
    .previewSurvey ul li:before {content: "-";color: #2f8bff;}
    .previewSurvey ul li .FileName{padding-left: 5px;padding-right: 5px;color: #ec6464;}
    .previewSurvey ul li .FileSize{padding-left: 5px;color: #ec6464;}
    .previewSurvey ul li .att-close{margin-bottom: -3px;margin-left: 8px;background: url('../../assets/images/file_del_btn.png') right bottom no-repeat;background-size: 15px 15px;width: 15px;height: 15px;display: inline-block;}

    .previewFile {margin: 10px 0;width: 100%;}
    .previewFile ul li{color: #696969;font-size: 12px;height: 24px; text-decoration: none;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;}
    .previewFile ul li:before {content: "-";color: #2f8bff;}
    .previewFile ul li .FileName{padding-left: 5px;padding-right: 5px;word-break: break-all;}
    .previewFile ul li .FileSize{padding-left: 5px;}
    .previewFile ul li .att-close{margin-bottom: -3px;margin-left: 8px;background: url('../../assets/images/file_del_btn.png') right bottom no-repeat;background-size: 15px 15px;width: 15px;height: 15px;display: inline-block;}

    .previewImg {margin: 10px 0 15px;height: 104px;width: 100%;overflow-y: hidden;overflow-x: auto;}
    .previewImg ul {height: 104px;white-space: nowrap;font-size: 0;line-height: 0;}
    .previewImg ul li {display: inline-block;padding: 0 30px 0 0;position: relative;}
    .previewImg ul li a {display: block;position: relative;}
    .previewImg ul li a div{position: absolute;left: 0;top: 0;}
    .previewImg ul li.sel:before {content: "대표";position: absolute;left: 0px;top: 0px;z-index: 2;display: inline-block;color: rgb(255, 255, 255);font-size: 12px;font-weight: 300;padding: 8px 5px 0px;background: rgb(66, 156, 253);border-radius: 0px 0px 4px;height: 11px;}
    .previewImg ul li.sel img {border: 2px solid #429cfd;}
    .previewImg ul li .img-close {text-indent: -999px;cursor: pointer;position: absolute;top: 0px;right: -20px;background: url('../../assets/images/file_del_btn.png') right top no-repeat;background-size: 15px 15px;width: 15px;height: 15px;display: inline-block;z-index: 3;}

</style>
